module.exports = __webpack_public_path__ + "static/media/quindio-74.93df0786.jpg";